// Colonne droppable générique du board « Mes tâches » (vues Par logement &
// Par échéance). En-tête = icône de tête (logement) OU pastille d'urgence
// (échéance) + libellé + compteur ; fond de colonne gris. Le statut passe en
// pastille sur la carte (showStatus). PRÉSENTATION SEULE — l'id de droppable
// et la sémantique du drag restent inchangés.

import { useDroppable } from '@dnd-kit/core'
import { DS } from '../../lib/ui'
import TaskCard from './TaskCard'
import { COLUMN_BG } from './taches-ui'

export default function TaskDropColumn({
  dropId, label, sublabel, tasks, cfg, labelsById, onEdit, onToggleDone,
  accentColor = null, headerIcon = null,
}) {
  const { setNodeRef, isOver } = useDroppable({ id: dropId })
  const accent = accentColor || DS.ciel

  return (
    <div
      ref={setNodeRef}
      data-testid={`task-dropcol-${dropId}`}
      style={{
        flex: 1,
        minWidth: 244,
        background: COLUMN_BG,
        borderRadius: 14,
        padding: 12,
        border: isOver ? `2px dashed ${accent}` : '0.5px solid transparent',
        boxShadow: isOver ? `inset 0 0 0 9999px ${accent}10` : 'none',
        transition: 'box-shadow .12s',
      }}
    >
      <div
        style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          gap: 8, marginBottom: 12, padding: '0 2px',
        }}
      >
        <span style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
          {headerIcon
            ? <span style={{ display: 'flex', color: accent, flexShrink: 0 }}>{headerIcon}</span>
            : <span style={{ width: 9, height: 9, borderRadius: '50%', background: accent, flexShrink: 0 }} />}
          <span
            style={{
              fontFamily: DS.fontDisplay, fontSize: 15, fontWeight: 600, color: DS.marineDark,
              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
            }}
          >
            {label}
            {sublabel && (
              <span style={{ fontFamily: DS.fontBody, fontSize: 11, fontWeight: 600, color: DS.textMuted, marginLeft: 6 }}>
                {sublabel}
              </span>
            )}
          </span>
        </span>
        <span
          style={{
            fontFamily: DS.fontDisplay, fontSize: 12, fontWeight: 600, color: DS.textSecondary,
            background: DS.card, borderRadius: 9, padding: '1px 9px', flexShrink: 0,
          }}
        >
          {tasks.length}
        </span>
      </div>

      {tasks.length === 0 && (
        <div style={{ fontSize: 12, color: DS.textMuted, fontStyle: 'italic', padding: '8px 4px' }}>
          Aucune tâche
        </div>
      )}

      {tasks.map(t => (
        <TaskCard
          key={t.id}
          task={t}
          cfg={cfg}
          labelsById={labelsById}
          onEdit={onEdit}
          onToggleDone={onToggleDone}
          showStatus
        />
      ))}
    </div>
  )
}
